import {primaryColor} from '../cmsMainStyle'

const iconStyle = theme => ({
    iconProperties: {
        [theme.breakpoints.up('sm')]: {
            color: primaryColor[5],
        },

        [theme.breakpoints.down('sm')]: {
            color: primaryColor[8],
        }
    },

})



export default iconStyle